import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

function MaintenanceModal({ open, onClose }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth aria-labelledby='maintenance-modal-title'>
            <DialogTitle id='maintenance-modal-title' style={{ paddingRight: 48 }}>
                Update Notice
                <IconButton
                    onClick={onClose}
                    aria-label='close dialog'
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant='body1'>
                    If you are looking for BuddyBooks, please login at our new site{' '}
                    <a href='https://buddybooks.objectiveed.com' target='_blank' rel='noopener noreferrer'>
                        BuddyBooks.objectiveed.com
                    </a>
                    .
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button color='primary' variant='contained' onClick={onClose}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MaintenanceModal;
